import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import CruiseLoyaltyPoints from 'components/Cruises/CruiseLoyaltyPoints'
import type { CruiseOnlyOfferView } from 'hooks/Cruise/useCruiseOfferView'
import CruiseOverviewPriceDetails from './CruiseOverviewPriceDetails'

export interface CruiseOverviewSinglePriceProps {
  view: CruiseOnlyOfferView
  hasValidDepartureDates: boolean
  showPackageOptions: () => void
}

function CruiseOverviewSinglePrice({ view, hasValidDepartureDates, showPackageOptions }: CruiseOverviewSinglePriceProps) {
  const { offer } = view

  return <Group direction="vertical" gap={16}>
    <Group direction="vertical" gap={16}>
      <CruiseOverviewPriceDetails view={view} hasValidDepartureDates={hasValidDepartureDates} priceType="standard" />
      <CruiseLoyaltyPoints offer={offer} calculationType="estimate" />
    </Group>
    <Group direction="vertical" gap={12}>
      {hasValidDepartureDates && <TextButton
        kind="secondary"
        onClick={showPackageOptions}
        fit="full-width"
      >
        <FormattedMessage
          id="jz0dx7BQ7GSRVwQkkFjH"
          defaultMessage="Check availability"
          description="Button text to check cruise availability in the cruise section"
        />
      </TextButton>}

      {!hasValidDepartureDates && <Group direction="vertical" gap={12}>
        <BodyText variant="large" weight="bold" align="center">
          <FormattedMessage
            id="Qfe77Kry9p_oD3uY5Uwi"
            defaultMessage="This offer has sold out"
            description="Message when cruise offer is sold out in the cruise offer or booking section"
          />
        </BodyText>
        <TextButton kind="secondary" to="/cruises">
          <FormattedMessage
            id="gdHYkGeOKO7bRK3FYwdz"
            defaultMessage="Browse all cruise offers"
            description="Link text to browse all cruise offers in the cruise offer or booking section"
          />
        </TextButton>
      </Group>}
    </Group>
  </Group>
}

export default CruiseOverviewSinglePrice
